<template>
  <div class="echarts" id="drugLeftthree"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  watchEffect,
  inject,
  nextTick,
} from "vue";
// import { securitylist } from "@/api/threeSolid/threeSolidHome.js";
import { dayPersonNum } from "@/api/publicSecurityResearch/drugControlModel.js";
import * as echarts from "echarts";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      nameList: [],
      valuelist: [],
    });
    const refData = toRefs(data);
    const ruleInfo = inject("ruleInfo");
    watchEffect(() => {
      if (ruleInfo.endDate || ruleInfo.startDate) {
        nextTick(() => {
          initCharts();
        });
      }
    });
    const numberall = async () => {
      const parms = {
        libareId: 1,
        endDate: ruleInfo.endDate,
        startDate: ruleInfo.startDate,
      };
      const res = await dayPersonNum(parms);
      const name = [];
      const value = [];
      res.data.forEach((item) => {
        name.push(item.name);
        value.push(item.value);
      });
      data.nameList = name;
      data.valuelist = value;
    };
    const initCharts = async () => {
      await numberall();
      const myChart = echarts.init(document.getElementById("drugLeftthree"));
      const option = {
        grid: {
          top: 40,
          left: 50,
          right: 30,
          bottom: 50,
          // containLabel: true
        },
        xAxis: {
          data: data.nameList, // ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
          },
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: data.valuelist, // [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#fefb54", // 折点颜色
                lineStyle: {
                  color: "#fefb54", // 折线颜色
                },
              },
            },
            areaStyle: {
              // 折线图颜色半透明
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,198,0, 0.5)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(255,198,0, 0.1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart.setOption(option, true);
    };
    onMounted(async () => {
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });

    return {
      ...refData,
    };
  },
});
</script>
<style lang="scss" scoped>
#drugLeftthree {
  width: 100%;
  height: 90%;
}
</style>
